import React, { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import { db } from "../firebase";
import "./CounsellingProgram.css";
import {
  Tooltip
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import f1 from "../assets/feature1.png";
import f2 from "../assets/feature2.png";
import f3 from "../assets/feature3.png";
import f4 from "../assets/feature5.png";
import f5 from "../assets/feature7.png";
import counsellor from "../assets/counseller.jpeg";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const SUBSCRIPTION_URL = "https://api.shooinstars.in/subscribe?uid=";
const TERMS_URL = "/terms";


export default function CounsellingProgram() {
  const [isPremium, setIsPremium] = useState(false);
  const [buyUrl, setBuyUrl] = useState("");
  const [buttonText, setButtonText] = useState("Loading...");
  const [buttonDisabled, setButtonDisabled] = useState(true);
  const [showInfo, setShowInfo] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [isRedirecting, setIsRedirecting] = useState(false);

  // -----------------------------
  // LOAD SUBSCRIPTION STATUS
  // -----------------------------

useEffect(() => {
  const uid = localStorage.getItem("uid");
  if (!uid) return;

  const userRef = ref(db, "users/" + uid);

  const unsubscribe = onValue(userRef, (snap) => {
    if (!snap.exists()) {
      enableBuy(uid);
      return;
    }

    const data = snap.val();
    const expiry = data.premium_expiry || 0;
    const now = Math.floor(Date.now() / 1000);

    if (!data.is_premium || expiry < now) {
      enableBuy(uid);
      return;
    }

    // Premium Active
    setButtonText("COUNSELING ACTIVATED");
    setButtonDisabled(true);
    setIsPremium(true);
  });

  return () => unsubscribe(); // cleanup listener
}, []);;



const enableBuy = (uid) => {
  setButtonText("ENROLL FOR COUNSELING PROGRAM");
  setButtonDisabled(false);
  setIsPremium(false);

  window.buyAction = () => {
    setIsRedirecting(true);   // 👈 show message
    setButtonDisabled(true);  // 👈 prevent double click

    setTimeout(() => {
      window.open(SUBSCRIPTION_URL + uid, "_blank");
      setIsRedirecting(false);  // optional (if user comes back)
      setButtonDisabled(false);
    }, 800);
  };
};

  const openInfo = (url) => {
  setVideoUrl(url);
  setShowInfo(true);
};

const closeInfo = () => {
  setShowInfo(false);
  setVideoUrl("");
};


  // -----------------------------
  // UI
  // -----------------------------

  return (
    <div className="cp-page">

    <div className="cp-wrapper">

      {/* ================= HERO ================= */}

      <section className="cp-hero">

  <h1>
    Expert-Guided Engineering Admission Counseling <br />
    for MHT-CET
  </h1>

        <p>
          End-to-End MHT-CET Counseling with Personalized Preference Lists,
          Non-CAP Guidance & Live Expert Support
        </p>

        <div className="cp-stats">
          <span>🏆 10+ Years Experience</span>
          <span>📊 Data Driven Preference Form & Predictor</span>
          <span>🎯 Non-CAP Experts</span>
          <span>🔴 Live Guidance by Kalpesh Hiwase</span>
        </div>
        {/* Hero Video Button - Bottom Center */}
<div className="hero-video-wrapper">

  <Tooltip
    title="Watch Now"
    placement="bottom"
    arrow
  >
    <span
      className="hero-video-btn"
      onClick={() =>
        openInfo(
          "https://player.vimeo.com/video/1166281961?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
        )
      }
    >
     ▶ Admission Guidance That Wins 
    </span>
  </Tooltip>

</div>


      </section>

      {/* ================= MAIN WHITE PANEL ================= */}

      <section className="cp-panel">

        {/* -------- COMPARISON -------- */}

<div className="cp-compare">

  {/* WITHOUT COUNSELLING */}
  <div className="compare-card compare-negative">
    <h3>Without Proper Counseling</h3>

    <ul>
      <li>❌ Wrong Preference Order</li>
      <li>❌ Missing Non-CAP Rounds</li>
      <li>❌ Wasting High Percentile</li>
      <li>❌ Falling for Agent Traps</li>
    </ul>
  </div>

  {/* WITH COUNSELLING */}
  <div className="compare-card compare-positive">
    <h3>With Shooin Stars Counseling</h3>

    <ul>
      <li>✅ Optimized Preference Lists</li>
      <li>✅ Complete Non-CAP Coverage</li>
      <li>✅ Best College for Your Score</li>
      <li>✅ Zero Confusion, Full Clarity</li>
    </ul>
  </div>

</div>
<div className="cp-compare">

  {/* WRONG COLLEGE COST */}
  <div className="compare-card compare-negative">
    <h3>Wrong College Cost</h3>

    <ul>
      <li>❌ ₹1–3 Lakh Extra Fees</li>
      <li>❌ Poor Placements</li>
      <li>❌ Regret for 4 Years</li>
    </ul>
  </div>

  {/* COUNSELING COST */}
  <div className="compare-card compare-positive">
    <h3>Counseling Cost</h3>

    <ul>
      <li>✅ ₹2,999 One-Time</li>
      <li>✅ Correct Admission Decision</li>
      <li>✅ Peace of Mind</li>
    </ul>
  </div>

</div>



        

        {/* -------- FEATURES -------- */}

        <h2 className="section-title">Our Key Features</h2>

        <div className="cp-features">

          <div className="feature-card">
            <img src={f1} alt="feature" />
            <h4>3 Preference List Generation (Each with Multiple Strategies)</h4>
            <p>No Guesswork</p>
          </div>

          <div className="feature-card">
            <img src={f2} alt="feature1" />
            <h4>5 Personalized College Predictor Reports</h4>
            <p>Best Options at Your Score</p>
          </div>

          <div className="feature-card">
            <img src={f3} alt="feature" />
            <h4>Live Expert Guidance</h4>
            <p>Step-by-Step Support</p>
          </div>

          <div className="feature-card">
            <img src={f4} alt="feature" />
            <h4>Engineering Foundation Course</h4>
            <p>Strong Academic Start</p>
          </div>

          <div className="feature-card">
            <img src={f5} alt="feature" />
            <h4>Non-CAP Info & Rounds</h4>
            <p>Unlock Hidden Colleges</p>
          </div>

        </div>



        {/* ================= WHAT YOU GAIN ================= */}

        <div className="cp-gain-wrapper">

          <h2 className="gain-title">
            What You <span>ACTUALLY</span> Gain from This Program
          </h2>

          <div className="cp-gain-box">

            {/* LEFT */}

            <div className="gain-left">

              <ul>
                <li><span>1</span> Best College at Your Score</li>
                <li><span>2</span> Avoid Admission Mistakes</li>
                <li><span>3</span> Clear CAP & Non-CAP Guidance</li>
                <li><span>4</span> Confidence in Counseling</li>
                <li><span>5</span> Strong Start in Engineering</li>
                <li><span>6</span> 10+ Years of Trusted Support</li>
                <li><span>7</span> Option to Extend Access for More Reports</li>
              </ul>

            </div>

            {/* RIGHT */}

            <div className="gain-right">

              <img src={counsellor} alt="Counsellor" />

              <div className="counsellor-card">

                <h4>Admission Counsellor – Kalpesh Hiwase</h4>

                <p>✔ B.E., MBA | UCLA-Certified Counselor</p>
                <p>✔ 10+ Years of MHT-CET Counseling Experience</p>
                <p>✔ Guided 8,000+ Students Successfully</p>
                <p>✔ CAP & ACAP Admission Strategy Expert</p>

              </div>

            </div>
            

          </div>
<div className="cost-card">

  <p className="cost-label">Costing</p>

  <h3 className="cost-title">Complete Counseling Program</h3>

  <div className="cost-price">
    ₹ 2,999<span> /- Only</span>
  </div>

  <p className="cost-meta">
    All Features <span className="dot">•</span> Instant Access
  </p>

</div>
        </div>

      </section>

      {/* ================= CTA ================= */}

<section className="cp-cta">

  {isPremium && (
    <p className="premium-text">
      ✅ Premium access is active
    </p>
  )}

  <p>
    By opting for this subscription you agree to our{" "}
    <span onClick={() => window.open(TERMS_URL, "_blank")}>
      Terms & Conditions
    </span>
  </p>

   <button
  className={isPremium ? "premium-btn-active" : ""}
  disabled={buttonDisabled}
  onClick={() => window.buyAction && window.buyAction()}
>
  {buttonText}
</button>

  {isRedirecting && (
    <div
      style={{
        marginTop: "18px",
        textAlign: "center",
        fontSize: "15px",
        fontWeight: "600",
        color: "#1e3a8a",
        background: "rgba(30, 58, 138, 0.08)",
        padding: "10px 18px",
        borderRadius: "30px",
        whiteSpace: "nowrap",
        display: "inline-block",
      }}
    >
      🔒 Redirecting to Shooin Stars Secure Portal...
    </div>
  )}

</section>
{/* Tutorial Video Dialog */}
<Dialog
  open={showInfo}
  onClose={closeInfo}
  maxWidth="md"
  fullWidth
>
  <DialogTitle
    sx={{
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }}
  >
    <Typography variant="h6">
      Watch Tutorial
    </Typography>

    <IconButton onClick={closeInfo}>
      <CloseIcon />
    </IconButton>
  </DialogTitle>

  <DialogContent dividers sx={{ p: 0 }}>
    <Box
      sx={{
        position: "relative",
        width: "100%",
        paddingTop: "56.25%", // 16:9 ratio
        backgroundColor: "#000"
      }}
    >
      <iframe
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          border: 0
        }}
        src={videoUrl}
        title="Admission Video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />
    </Box>
  </DialogContent>
</Dialog>



    </div>
    </div>

  );
}
